import { Loader2, MessageSquare } from 'lucide-react'

import { Button } from '@/shared/components/ui/button'
import { Textarea } from '@/shared/components/ui/textarea'

export default function CommentInput({
  value,
  onChange,
  onSubmit,
  loading = false,
}) {
  return (
    <div className="border-t bg-white px-4 py-2">
      <h3 className="mb-4 text-sm font-bold uppercase tracking-[0.15em] text-slate-500">
        Add Comment
      </h3>

      <Textarea
        rows={3}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Type your internal note here..."
        className="min-h-[96px] resize-none rounded-[20px] border bg-white px-5 py-4 text-[15px] shadow-sm focus-visible:ring-0"
      />

      <div className="mt-5 flex justify-end">
        <Button
          onClick={onSubmit}
          disabled={loading || !value.trim()}
          className="h-11 rounded-xl px-6 bg-[#0F172A] hover:bg-[#0F172A]"
        >
          {loading ? (
            <>
              <Loader2 className="mr-2 size-4 animate-spin" />
              Adding...
            </>
          ) : (
            <>
              <MessageSquare className="mr-2 size-4 " />
              Add Comment
            </>
          )}
        </Button>
      </div>
    </div>
  )
}
